import {mainQuery} from '@github-ui/react-core/future/main-query'

import {agentFinderAppBuilder} from '../config/app-builder'

import type {AgentFinderResponse} from '../types'

export const agentFinderRoute = agentFinderAppBuilder.createQueryRouteConfig('agentFinderRoute', {
  path: '/agentfinder',
  queries: [
    mainQuery<AgentFinderResponse>({
      queryDeps: ({pathname, searchParams}) => {
        const params = new URLSearchParams()

        // v0.1 API uses 'search' parameter and page-based pagination
        const search = searchParams.get('search') || ''
        const page = searchParams.get('page') || '1'

        params.set('page', page)
        if (search) params.set('search', search)

        // Resource type filter is applied server-side (comma-separated labels).
        // Including it here ensures changing the filter triggers a refetch.
        const type = searchParams.get('type') || ''
        if (type) params.set('type', type)

        const pathWithParams = params.toString() ? `${pathname}?${params.toString()}` : pathname

        return {pathname: pathWithParams}
      },
    }),
  ],
})
